export default {
    ATENDIMENTO: 1,
    EXAME: 2
}